import {
  EMPLOYEEASSESSMENT_LOADING,
  GET_EMPLOYEEASSESSMENT,
  GET_EMPLOYEEASSESSMENT_SUCCESS,
  GET_EMPLOYEEASSESSMENT_FAIL,
  ADD_EMPLOYEEASSESSMENT_SUCCESS,
  ADD_EMPLOYEEASSESSMENT_FAIL,
  DELETE_EMPLOYEEASSESSMENT_SUCCESS,
  DELETE_EMPLOYEEASSESSMENT_FAIL,
  UPDATE_EMPLOYEEASSESSMENT_SUCCESS,
  UPDATE_EMPLOYEEASSESSMENT_FAIL,
  EMPLOYEEASSESSMENT_RESET
} from "./actionType";

const INIT_STATE = {
  employeeAssessments: [],
  error: {},
};

const EmployeeAssessment = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEEASSESSMENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEEASSESSMENT:
          return {
            ...state,
            employeeAssessments: action.payload.data,
            isEmployeeAssessmentCreated: false,
            isEmployeeAssessmentSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEEASSESSMENT_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEEASSESSMENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeAssessmentCreated: false,
            isEmployeeAssessmentSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEEASSESSMENT: {
      return {
        ...state,
        isEmployeeAssessmentCreated: false,
        loading: true,
      };
    }

    case EMPLOYEEASSESSMENT_LOADING: {
      return {
        ...state,
        isEmployeeAssessmentCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEEASSESSMENT_SUCCESS:
      return {
        ...state,
        isEmployeeAssessmentCreated: true,
        loading: false,
        employeeAssessments: [action.payload.data, ...state.employeeAssessments],
      };

    case ADD_EMPLOYEEASSESSMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEEASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        isEmployeeAssessmentCreated: true,
        employeeAssessments: state.employeeAssessments.filter(
          employeeAssessment => employeeAssessment.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEEASSESSMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEEASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        isEmployeeAssessmentCreated: true,
        employeeAssessments: state.employeeAssessments.map(employeeAssessment =>
          employeeAssessment.id.toString() === action.payload.data.id.toString() ? { ...employeeAssessment, ...action.payload.data } : employeeAssessment
        ),
      };

    case UPDATE_EMPLOYEEASSESSMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EMPLOYEEASSESSMENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default EmployeeAssessment;